import React from 'react';
import SidebarFrame from "./SidebarFrame";
import MeasureNumberInput from "../commons/MeasureNumberInput.js";

export default class TrennwandboxSettings extends SidebarFrame {

    renderTitle() {
        return I18N("Trennwandbox");
    }

    getSidebarParent() {
        return "einbauten";
    }

    renderBody() {
        const trennwandbox = this.props.model.vsData;

        const element = trennwandbox.elements[0];

        return (
            <div className="appear">
                <MeasureNumberInput label={I18N(`Wie breit soll die linke Hälte sein?`)} value={element.size.x} onCommit={APP.model.tryWrap(this,value=>{
                        element.size.x=value;
                        element.locked.x=true;
                })} />
                <MeasureNumberInput label={I18N(`Breite der rechten Seite`)} value={trennwandbox.elements[1].size.x} disabled={true}/>
            </div>
        )
    }
}